export const faqData = {
    hilfy: {
        chunk_1: [
            {
                id: 'faq__body_0',
                question: {
                    title: "WARUM HILFY?"
                },
                answer: {
                    p: [
                        "Unsere Hilfy-Experten zählen zu den besten Allround-Handwerkern in Österreich. Wir senden immer nur unsere eigenen Mitarbeiter zu Ihnen, die erfahren, freundlich und professionell arbeiten.",
                        "Was uns noch ausmacht?"
                    ],
                    li: [ 
                        {title: "Allround Service", text: "Hilfy deckt Reparaturen aus den Bereichen Elektrotechnik, Gas-, Wasser- und Heizungstechnik und jede Art von handwerklichen Arbeiten in Privathaushalten ab."},
                        {title: "Schnell", text: "Fragen Sie innerhalb von 3 Minuten einen Handwerker an. Sie bestimmen den Termin. Egal, ob heute, morgen oder nächste Woche – wir sind sofort für Sie einsetzbar."},
                        {title: "Unkompliziert", text: "Wir bezeichnen uns gerne als Werkstatt auf Rädern. Materialien und Werkzeug bringen wir mit. Ist schon alles vorhanden, verwenden wir Ihre Materialien."},
                        {title: "Zuverlässig", text: "Zuverlässigkeit und Pünktlichkeit stehen bei uns an oberster Stelle. Wir halten uns an Termine und führen die Arbeiten schnellstmöglich aus."},
                    ]
                },  
            },
            {
                id: 'faq__body_1',
                question: {
                    title: "WELCHE ARBEITEN ÜBERNIMMT HILFY?"
                },
                answer: {
                    p: [
                        "Wir erledigen Reparaturen aller Art. Dabei ist es egal, ob es um Elektroarbeiten, Arbeiten im Bereich Heizung, Gas, Sanitär oder um Montage geht. Wir schließen Ihren Herd an, entlüften Ihre Heizung, schließen das Leck am Wasserhahn und montieren Ihre Schränke und Regale – wir sind Allround-Handwerker. Auch die Entsorgung von Sperrmüll und Elektrogeräten übernehmen wir für Sie."
                    ]
                },  
            },
            {
                id: 'faq__body_2',
                question: {
                    title: "WIE SCHNELL KOMMT EIN ALLROUND-HANDWERKER ZU MIR?"
                },
                answer: {
                    p: [
                        "Unsere Handwerker sind sofort für Sie einsatzbereit. Sie möchten lieber erst in einigen Tagen einen Termin? Kein Problem – teilen Sie uns Ihren Wunschtermin einfach über das Formular oder telefonisch mit."
                    ]
                },  
            },
            {
                id: 'faq__body_3',
                question: {
                    title: "WIE LANGE DAUERT DIE REPARATUR?"
                },
                answer: {
                    p: [
                        "Die Dauer der Reparatur ermitteln wir im Telefonat mit Ihnen. Einer unserer Mitarbeiter schätzt den Schaden professionell ein und teilt Ihnen die benötigte Arbeitszeit und damit die Kosten direkt mit. So können Sie zuverlässig mit uns planen."
                    ]
                },  
            },
            {
                id: 'faq__body_4',
                question: {
                    title: "IN WELCHEM UMKREIS KANN ICH DEN SERVICE VON HILFY BUCHEN?"
                },
                answer: {
                    p: [
                        "Unsere Werkstatt auf Rädern ist innerhalb von Wien und Umgebung, sowie in Graz und Umgebung unterwegs."
                    ]
                },  
            }
        ],
        chunk_2: [ 
            {
                id: 'faq__body_5',
                question: {
                    title: "WELCHE MATERIALIEN VERWENDET DER HANDWERKER?"
                },
                answer: {
                    p: [ 
                        "Unsere Allrounder verwenden nur zertifizierte und professionelle Materialien von zuverlässigen europäischen Herstellern. Auf unsere Arbeit geben wir eine Garantie von 3 Monaten – denn Qualität und hochwertige Arbeit stehen bei uns im Vordergrund."
                    ]
                },  
            },
            {
                id: 'faq__body_6',
                question: {
                    title: "ICH KANN DAS PROBLEM SCHLECHT BESCHREIBEN. WIE GEHEN SIE VOR?"
                },
                answer: {
                    p: [
                        "Wenn Sie sich nicht sicher sind, welcher Schaden entstanden ist, ist das kein Problem. Unser Mitarbeiter wird sich den Schaden vor Ort ansehen und Ihnen direkt eine professionelle Einschätzung geben, wie lange die Reparatur dauert und was sie kostet. Nach Ihrer Bestätigung führt er die Reparatur direkt durch."
                    ]
                },  
            },
            {
                id: 'faq__body_7',
                question: {
                    title: "WERDEN DIE RECHNUNGEN VON HILFY VON MEINER VERSICHERUNG AKZEPTIERT?"
                },
                answer: {
                    p: [
                        "Ja. Sie erhalten von uns nach dem Auftrag eine Rechnung per E-Mail. Diese wird von den Versicherungen akzeptiert."
                    ]
                },  
            },
            {
                id: 'faq__body_8',
                question: {
                    title: "WIE KANN ICH BEZAHLEN?"
                },
                answer: {
                    p: [
                        "Sie können direkt vor Ort auf Rechnung, in bar oder über ein Bankterminal bezahlen, das unser Handwerker mitbringt. In jedem Fall zahlen Sie erst nach Ausführung der Arbeit und wenn Sie damit zufrieden sind. Im Anschluss erhalten Sie eine Rechnung per E-Mail."
                    ]
                },  
            },
        ]
    },
    profy: {
        chunk_1: [
            {
                id: 'faq__body_v2_0',
                question: {
                    title: "WARUM PROFY?"
                },
                answer: {
                    p: [
                        "Unsere Profy-Experten zählen zu den besten Allround-Handwerkern in Düsseldorf. Wir senden immer nur unsere eigenen Mitarbeiter zu Ihnen, die erfahren, freundlich und professionell arbeiten.",
                        "Was uns noch ausmacht?"
                    ],
                    li: [ 
                        {title: "Allround Service", text: "Profy deckt Kleinreparaturen aus den Bereichen Elektro, Heizung, Sanitär und Montage ab – alles aus einer Hand."},
                        {title: "Schnell", text: "Fragen Sie innerhalb von 3 Minuten einen Handwerker an. Sie bestimmen den Termin. Egal, ob heute, morgen oder nächste Woche – wir sind sofort für Sei einsetzbar."},
                        {title: "Unkompliziert", text: "Wir bezeichnen uns gerne als Werkstatt auf Rädern. Materialien und Werkzeug bringen wir mit. Ist schon alles vorhanden, verwenden wir Ihre Materialien."},
                        {title: "Zuverlässig", text: "Zuverlässigkeit und Pünktlichkeit stehen bei uns an oberster Stelle. Wir halten uns an Termine und führen die Arbeiten schnellstmöglich aus."},
                    ]
                },  
            },
            {
                id: 'faq__body_v2_1',
                question: {
                    title: "WELCHE ARBEITEN ÜBERNIMMT PROFY?"
                },
                answer: {
                    p: [
                        "Unser Fokus liegt klar auf Kleinreparaturen. Dabei ist es egal, ob es um Elektroarbeiten, Arbeiten im Bereich Heizung und Sanitär oder um Montage geht. Wir schließen Ihren Herd an, entlüften Ihre Heizung, schließen das Leck am Wasserhahn und montieren Ihre Schränke und Regale – wir sind Allround Handwerker. Auch die Entsorgung von Sperrmüll und Elektrogeräten übernehmen wir für Sie."
                    ]
                },  
            },
            {
                id: 'faq__body_v2_2',
                question: {
                    title: "WIE SCHNELL KOMMT EIN ALLROUND HANDWERKER ZU MIR?"
                },
                answer: {
                    p: [
                        "Unsere Handwerker sind sofort für Sie einsetzbar. Sie möchten lieber erst in einigen Tagen einen Termin? Kein Problem – teilen Sie uns Ihren Wunschtermin einfach über das Formular oder telefonisch mit."
                    ]
                },  
            },
            {
                id: 'faq__body_v2_3',
                question: {
                    title: "WIE LANGE DAUERT DIE REPARATUR?"
                },
                answer: {
                    p: [
                        "Die Dauer der Reparatur ermitteln wir im Telefonat mit Ihnen. Einer unserer Mitarbeiter schätzt den Schaden professionell ein und teilt Ihnen die benötigte Arbeitszeit und damit die Kosten direkt mit. So können Sie zuverlässig mit uns planen."
                    ]
                },  
            },
            {
                id: 'faq__body_v2_4',
                question: {
                    title: "IN WELCHEM UMKREIS KANN ICH DEN SERVICE VON PROFY BUCHEN?"
                },
                answer: {
                    p: [
                        "Unsere Werkstatt auf Rädern ist innerhalb von Düsseldorf unterwegs. Wir bieten unseren Service aus Düsseldorf für Düsseldorf an."
                    ]
                },  
            },
        ],
        chunk_2: [
            {
                id: 'faq__body_v2_5',
                question: {
                    title: "WELCHE MATERIALIEN VERWENDET DER HANDWERKER?"
                },
                answer: {
                    p: [
                        "Unsere Allrounder verwenden nur zertifizierte und professionelle Materialien von zuverlässigen europäischen Herstellern. Auf unsere Arbeit geben wir eine Garantie von 3 Monaten – denn Qualität und hochwertige Arbeit stehen bei uns im Vordergrund."
                    ]
                },  
            },
            {
                id: 'faq__body_v2_6',
                question: {
                    title: "ICH KANN DAS PROBLEM SCHLECHT BESCHREIBEN. WIE GEHEN SIE VOR?"
                },
                answer: {
                    p: [
                        "Sind Sie sich nicht sicher, welcher Schaden entstanden ist, ist das kein Problem. Unser Mitarbeiter wird sich den Schaden vor Ort ansehen und Ihnen direkt eine professionelle Einschätzung geben, wie lange die Reparatur dauert und was sie kostet. Nach Ihrer Bestätigung führt er die Reparatur direkt durch."
                    ]
                },  
            },
            {
                id: 'faq__body_v2_7',
                question: {
                    title: "WERDEN DIE RECHNUNGEN VON PROFY VON MEINER VERSICHERUNG AKZEPTIERT?"
                },
                answer: {
                    p: [
                        "Ja. Sie erhalten von uns nach dem Auftrag eine Rechnung per E-Mail. Diese wird von den Versicherungen akzeptiert."
                    ]
                },  
            },
            {
                id: 'faq__body_v2_8',
                question: {
                    title: "WIE KANN ICH BEZAHLEN?"
                },
                answer: {
                    p: [
                        "Sie können direkt vor Ort auf Rechnung, in bar oder über ein Bankterminal bezahlen, das unser Handwerker mitbringt. In jedem Fall zahlen Sie erst nach Ausführung der Arbeit und wenn Sie damit zufrieden sind. Im Anschluss erhalten Sie eine Rechnung per E-Mail."
                    ]
                },  
            },
        ]
    }
}
